import type { PhotoResponse } from "../../types/photo/PhotoResponse";
import type { UpsertPhoto } from "../../types/photo/UpsertPhoto";
import type { ModuleSettings } from "../../types/photo/ModuleSettings";

import Repository from "./Repository";

export const photoRepository = {
    async photo(): Promise<PhotoResponse> {
        const response = await Repository.post<PhotoResponse>('photo/photo');
        return response.data;
    },

    async upsertPhoto(file: File): Promise<UpsertPhoto> {
        const data = new FormData();
        data.set('formFile', file);
        const response = await Repository.post<UpsertPhoto>('photo/upsertPhoto', data);
        return response.data;
    },

    async deletePhotoChangeReq(pPhoto: number): Promise<void> {
        const data = new FormData();
        data.set('pPhoto', pPhoto.toString());
        await Repository.post<void>('photo/deletePhotoChangeReq', data);
    },

    async moduleSettings(): Promise<ModuleSettings> {
        const response = await Repository.post<ModuleSettings>('photo/moduleSettings');
        return response.data;
    },
};
